import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { Alert, Button, Loader, Modal, Table } from '@itds/elements';

import EditCategoryDrawer from '@carrier/pages/carriers/life_quotes/health_categories/Edit';

import Api from '@carrier/utils/Api';

const List = () => {
  const params = useParams();

  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error_message, setErrorMessage] = useState(null);
  const [success_message, setSuccessMessage] = useState(null);
  const [modal, setModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);

  useEffect(() => {
    loadHealthCategories();
  }, []);

  const loadHealthCategories = action => {
    setLoading(true);

    setTimeout(() => {
      setSuccessMessage(null);
      setErrorMessage(null);
    }, 2000);

    Api.loadHealthCategories({ carrier_id: params.id, data_version_id: params.version_id })
      .then(({ data }) => {
        setCategories(data);
        setLoading(false);
        if (action === 'add') {
          setSuccessMessage('Health Category Successfully Added');
        } else if (action === 'delete') {
          setSuccessMessage('Health Category Successfully Deleted');
        }
      })
      .catch(() => {
        if (action === 'add') {
          setErrorMessage('Unable to add Health Category at this time');
        } else if (action === 'delete') {
          setErrorMessage('Unable to delete Health Category at this time');
        }
      });
  };

  const handleSave = () => {
    setCategory(null);
    loadHealthCategories('add');
  };

  const handleDelete = (obj, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);
    setModal(true);
    setDeleteInfo(obj);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);
    Api.deleteHealthCategory(deleteInfo.id)
      .then(() => {
        loadHealthCategories('delete');
        setModal(null);
        setDeleteInfo(null);
      })
      .catch(() => {
        setModal(null);
        setDeleteInfo(null);
      });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      <EditCategoryDrawer
        category={category}
        onClose={setCategory.bind(null, null)}
        onSave={handleSave}
        show={!!category}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button
          onClick={setCategory.bind(null, {
            carrier_id: params.id,
            data_version_id: params.version_id
          })}
        >
          Add Health Category
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'carrier_health_category',
            label: 'Health Category'
          },
          {
            id: 'id',
            label: 'ID'
          },
          {
            id: 'ien_health_category',
            label: 'IEN System Mapping'
          },
          {
            id: 'tobacco_category_type',
            label: 'Tobacco Category Type'
          },
          {
            id: 'updated_at',
            label: 'Last Updated',
            render: category => format(new Date(category.updated_at), 'MM/dd/yyyy')
          },
          {
            id: 'actions',
            render: row => {
              return (
                <div>
                  <Button
                    color='RED'
                    inline={true}
                    onClick={handleDelete.bind(null, row)}
                    small={true}
                  >
                    Delete
                  </Button>
                </div>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={categories}
        onRowClick={setCategory}
      />

      {modal ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${deleteInfo.carrier_health_category}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{deleteInfo.carrier_health_category}"?
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default List;
